// @flow
import React from 'react'
import styled from 'styled-components'

const StyledSVG = styled.svg`
  width: 100px;
  height: 100px;
  -webkit-animation: loaderRotate 2s linear infinite;
  animation: loaderRotate 2s linear infinite;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;

  @-webkit-keyframes loaderRotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes loaderRotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`

const StyledCircle = styled.circle`
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  -webkit-animation: loaderDash 1.5s ease-in-out infinite, loaderColor 6s ease-in-out infinite;
  animation: loaderDash 1.5s ease-in-out infinite, loaderColor 6s ease-in-out infinite;
  stroke-linecap: round;

  @-webkit-keyframes loaderDash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
  @keyframes loaderDash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }

  @-webkit-keyframes loaderColor {
    0% {
      stroke: #4a5665;
    }
    40% {
      stroke: #4a5665;
    }
    66% {
      stroke: #4a5665;
    }
    80%,
    90% {
      stroke: #4a5665;
    }
  }
  @keyframes loaderColor {
    0% {
      stroke: #4a5665;
    }
    40% {
      stroke: #4a5665;
    }
    66% {
      stroke: #4a5665;
    }
    80%,
    90% {
      stroke: #4a5665;
    }
  }
`

const LoadingCircle = () => {
  return (
    <StyledSVG viewBox="25 25 50 50">
      <StyledCircle cx="50" cy="50" r="20" fill="none" stroke="#4a5665" strokeWidth="2.5" />
    </StyledSVG>
  )
}

export default LoadingCircle



// WEBPACK FOOTER //
// ./src/components/Icons/LoadingCircle.js